import { simpleSet } from '@r/reducers/utils';

const setCalculationModeHingesOptions = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.hinges.options;

export const options = setCalculationModeHingesOptions(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_HINGES_OPTIONS',
  []
);
